// import React, { useEffect, useState } from "react";
// import { Col, Form, Row, Spinner, Table } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { authHeader } from "../../../services/auth-header";
// import { BASE_URL } from "../../../services/Api";

// const unitOptions = [
//   { value: "bot (bottle)", label: "Bot (Bottle)" },
//   { value: "ctn (carton)", label: "Ctn (Carton)" },
//   { value: "days", label: "Days" },
//   { value: "ft (feet)", label: "Ft (Feet)" },
//   { value: "hrs (hour)", label: "Hrs (Hour)" },
//   { value: "kg (kilogram)", label: "Kg (Kilogram)" },
//   { value: "kgs.", label: "Kgs." },
//   { value: "ltr (littre)", label: "Ltr (Littre)" },
//   { value: "mtr", label: "Mtr" },
//   { value: "nos (number)", label: "Nos (Number)" },
//   { value: "pil (pail)", label: "Pil (Pail)" },
//   { value: "pkt (packet)", label: "Pkt (Packet)" },
//   { value: "set (sets)", label: "Set (Sets)" },
//   { value: "pcs (pcs)", label: "Pcs (Pcs)" },
// ];

// const PIMRNView = () => {
//   const { id } = useParams();
//   const [isLoading, setIsLoading] = useState(false);
//   const [state, setState] = useState({
//     mrnno: '', mrndate: '', deliverynoteno: '', deliverynotedate: '',
//     pono: '', podate: '', status: '', shipto: '',
//     supplier: null, supplierDetails: {}, supplierMultipleAddress: null,
//     branch: null, warehouse: null, rows: []
//   });

//   useEffect(() => {
//     getPurchaseOrderDetails();
//   }, []);

//   const getPurchaseOrderDetails = async () => {
//     try {
//       setIsLoading(true);
//       const { data } = await axios.get(`${BASE_URL}materialReceiptNote/findById/${id}`, {
//         headers: authHeader(),
//       });

//       setState({
//         mrnno: data.mrnno || '',
//         mrndate: data.mrndate || '',
//         deliverynoteno: data.deliverynoteno || '',
//         deliverynotedate: data.deliverynotedate || '',
//         pono: data.pono || '',
//         podate: data.podate || '',
//         status: data.status || '',
//         shipto: data.shipto || '',
//         supplier: data.supplier ? { value: data.supplier.id, label: data.supplier.companyname } : null,
//         supplierDetails: {
//           contactperson: data.contactperson || '',
//           contactno: data.contactno || '',
//           email: data.email || ''
//         },
//         supplierMultipleAddress: data.supplierMultipleAddress ? {
//           value: data.supplierMultipleAddress.id,
//           label: data.supplierMultipleAddress.supplieraddress
//         } : null,
//         branch: data.branch ? { value: data.branch.id, label: data.branch.branchname } : null,
//         warehouse: data.warehouse ? { value: data.warehouse.id, label: data.warehouse.warehousename } : null,
//         rows: data.materialReceiptNoteItems?.map(item => ({
//           product: { name: item.product.description },
//           quantity: item.quantity,
//           unitrateinr: item.unitrateinr,
//           totalinr: item.totalinr,
//           uom: item.product.unitofmeasurement,
//           productremarks: item.productremarks,
//           partno: item.partno,
//           hsnsacno: item.hsnsacno,
//           serialnumber: item.serialnumber,
//           igst: item.gst,
//           moc: item.moc,
//           type: item.type,
//           size: item.size,
//           rating: item.rating,
//           classes: item.classes,
//           schedule: item.schedule,
//           certification: item.certification,
//           mtrno: item.mtrno,
//           detailmaterialdescription: item.detailmaterialdescription,
//           make: item.make,
//           ifanyremarks: item.ifanyremarks,
//           mfgsrno: item.mfgsrno,
//           heatnobatchno: item.heatnobatchno,
//           platenosrno: item.platenosrno,
//           quantityreceived: item.quantityreceived,
//         })) || []
//       });

//       setIsLoading(false);
//     } catch (error) {
//       setIsLoading(false);
//       Swal.fire({ icon: "error", title: "Error", text: "Failed to fetch GRN details." });
//     }
//   };

//   return (
//     <div className="container">
//       <br />
//       {isLoading ? (
//         <div className="text-center py-5">
//           <Spinner animation="border" />
//           <p>Loading GRN details...</p>
//         </div>
//       ) : (
//         <Form>
//           <Row>
//             <Col md={6}><p><strong>GRN No:</strong> {state.mrnno}</p></Col>
//             <Col md={6}><p><strong>GRN Date:</strong> {state.mrndate}</p></Col>
//             <Col md={6}><p><strong>Delivery Note No:</strong> {state.deliverynoteno}</p></Col>
//             <Col md={6}><p><strong>Delivery Note Date:</strong> {state.deliverynotedate}</p></Col>
//             <Col md={6}><p><strong>PO No:</strong> {state.pono}</p></Col>
//             <Col md={6}><p><strong>PO Date:</strong> {state.podate}</p></Col>
//             <Col md={6}><p><strong>Status:</strong> {state.status}</p></Col>
//           </Row>

//           <hr />
//           <h5>Branch & Warehouse Details</h5>
//           <hr />
//           <Row>
//             <Col md={6}><p><strong>Branch:</strong> {state.branch?.label || '-'}</p></Col>
//             <Col md={6}><p><strong>Warehouse:</strong> {state.warehouse?.label || '-'}</p></Col>
//             <Col md={12}><p><strong>Delivery Address:</strong> {state.shipto || '-'}</p></Col>
//           </Row>

//           <hr />
//           <h5>Supplier Details</h5>
//           <hr />
//           <Row>
//             <Col md={6}><p><strong>Supplier:</strong> {state.supplier?.label || '-'}</p></Col>
//             <Col md={6}><p><strong>Contact Person:</strong> {state.supplierDetails.contactperson || '-'}</p></Col>
//             <Col md={6}><p><strong>Contact No:</strong> {state.supplierDetails.contactno || '-'}</p></Col>
//             <Col md={6}><p><strong>Email:</strong> {state.supplierDetails.email || '-'}</p></Col>
//             <Col md={12}><p><strong>Supplier Address:</strong> {state.supplierMultipleAddress?.label || '-'}</p></Col>
//           </Row>

//           <hr />
//           <h5>Product Items</h5>
//           <div className="table-responsive">
//             <Table striped bordered hover>
//               <thead>
//                 <tr>
//                   <th>Product Description</th>
//                   <th>Remarks</th>
//                   <th>MTR No</th>
//                   <th>Detail Material Description</th>
//                   <th>Make</th>
//                   <th>Mfg. Sr. No</th>
//                   <th>Heat No / Batch No</th>
//                   <th>Plate No./ Sr. No</th>
//                   <th>Quantity Received</th>
//                   <th>UOM</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {state.rows.map((row, index) => (
//                   <tr key={index}>
//                     <td>
//                       {row.product.name}
//                     </td>
//                     <td>{row.productremarks || '-'}</td>
//                     <td>{row.mtrno || '-'}</td>
//                     <td>{row.detailmaterialdescription || '-'}</td>
//                     <td>{row.make || '-'}</td>
//                     <td>{row.mfgsrno || '-'}</td>
//                     <td>{row.heatnobatchno || '-'}</td>
//                     <td>{row.platenosrno || '-'}</td>
//                     <td>{row.quantityreceived || '-'}</td>
//                     <td>{row.uom || '-'}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         </Form>
//       )}
//     </div>
//   );
// };

// export default PIMRNView;




import React, { useEffect, useState } from "react";
import { Col, Row, Table, Spinner, Card, Badge, Container } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";
import { FaArrowLeft } from "react-icons/fa";

const PIMRNView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    mrnno: '', mrndate: '', deliverynoteno: '', deliverynotedate: '',
    pono: '', podate: '', status: '', shipto: '',
    supplier: null, supplierDetails: {}, supplierMultipleAddress: null,
    branch: null, warehouse: null, rows: []
  });

  useEffect(() => {
    getPurchaseOrderDetails();
  }, []);

  const getPurchaseOrderDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`${BASE_URL}materialReceiptNote/findById/${id}`, {
        headers: authHeader(),
      });

      setState({
        mrnno: data.mrnno || '',
        mrndate: data.mrndate || '',
        deliverynoteno: data.deliverynoteno || '',
        deliverynotedate: data.deliverynotedate || '',
        pono: data.pono || '',
        podate: data.podate || '',
        status: data.status || '',
        shipto: data.shipto || '',
        supplier: data.supplier ? { value: data.supplier.id, label: data.supplier.companyname } : null,
        supplierDetails: {
          contactperson: data.contactperson || '',
          contactno: data.contactno || '',
          email: data.email || ''
        },
        supplierMultipleAddress: data.supplierMultipleAddress ? {
          value: data.supplierMultipleAddress.id,
          label: data.supplierMultipleAddress.supplieraddress
        } : null,
        branch: data.branch ? { value: data.branch.id, label: data.branch.branchname } : null,
        warehouse: data.warehouse ? { value: data.warehouse.id, label: data.warehouse.warehousename } : null,
        rows: data.materialReceiptNoteItems?.map(item => ({
          product: { name: item.product.description },
          quantity: item.quantity,
          unitrateinr: item.unitrateinr,
          totalinr: item.totalinr,
          uom: item.product.unitofmeasurement,
          productremarks: item.productremarks,
          partno: item.partno,
          hsnsacno: item.hsnsacno,
          serialnumber: item.serialnumber,
          igst: item.gst,
          moc: item.moc,
          type: item.type,
          size: item.size,
          rating: item.rating,
          classes: item.classes,
          schedule: item.schedule,
          certification: item.certification,
          mtrno: item.mtrno,
          detailmaterialdescription: item.detailmaterialdescription,
          make: item.make,
          ifanyremarks: item.ifanyremarks,
          mfgsrno: item.mfgsrno,
          heatnobatchno: item.heatnobatchno,
          platenosrno: item.platenosrno,
          quantityreceived: item.quantityreceived,
        })) || []
      });

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Swal.fire({ icon: "error", title: "Error", text: "Failed to fetch GRN details." });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Draft': return 'secondary';
      case 'Submitted': return 'primary';
      case 'Approved': return 'success';
      case 'Rejected': return 'danger';
      case 'Completed': return 'info';
      default: return 'light';
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">GOODS RECEIPT NOTE - VIEW</h5>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-1" />
              Back
            </button>
          </div>
          
          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">GRN No</small>
                <div className="fw-bold">{state.mrnno}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">GRN Date</small>
                <div className="fw-bold">{formatDate(state.mrndate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">PO No</small>
                <div className="fw-bold">{state.pono || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge 
                    bg={getStatusBadge(state.status)} 
                    className="px-2 py-1"
                  >
                    {state.status}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Delivery Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Delivery Information</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Delivery Note No</small>
                <div className="fw-bold">{state.deliverynoteno || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Delivery Note Date</small>
                <div className="fw-bold">{formatDate(state.deliverynotedate)}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">PO Date</small>
                <div className="fw-bold">{formatDate(state.podate)}</div>
              </div>
              <div>
                <small className="text-muted">Delivery Address</small>
                <div className="fw-bold">{state.shipto || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Branch</small>
                <div className="fw-bold">{state.branch?.label || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Warehouse</small>
                <div className="fw-bold">{state.warehouse?.label || '-'}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Supplier Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Supplier Details</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Company Name</small>
                <div className="fw-bold">{state.supplier?.label || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Contact Person</small>
                <div className="fw-bold">{state.supplierDetails.contactperson || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Phone</small>
                <div className="fw-bold">{state.supplierDetails.contactno || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Email</small>
                <div className="fw-bold">{state.supplierDetails.email || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div>
                <small className="text-muted">Address</small>
                <div className="fw-bold">
                  {state.supplierMultipleAddress?.label || '-'}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Product Items */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Received Items</h6>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Product Description</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2">MTR No</th>
                  <th className="fw-bold py-2">Material Description</th>
                  <th className="fw-bold py-2">Make</th>
                  <th className="fw-bold py-2">Mfg Sr No</th>
                  <th className="fw-bold py-2">Heat/Batch No</th>
                  <th className="fw-bold py-2">Plate/Sr No</th>
                  <th className="fw-bold py-2 text-center">Qty Received</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                </tr>
              </thead>
              <tbody>
                {state.rows.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{row.product.name}</div>
                      {row.productremarks && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {row.productremarks}</small>
                        </div>
                      )}
                      <div className="text-muted small mt-1">
                        {[
                          { label: "MOC", value: row.moc },
                          { label: "Type", value: row.type },
                          { label: "Size", value: row.size },
                          { label: "Rating", value: row.rating },
                          { label: "Class", value: row.classes },
                          { label: "Schedule", value: row.schedule },
                          { label: "Certification", value: row.certification },
                        ].filter(item => item.value).map((item, idx) => (
                          <div key={idx}>
                            <small><strong>{item.label}:</strong> {item.value}</small>
                          </div>
                        ))}
                      </div>
                    </td>
                    <td>{row.partno || '-'}</td>
                    <td>{row.hsnsacno || '-'}</td>
                    <td>{row.mtrno || '-'}</td>
                    <td>{row.detailmaterialdescription || '-'}</td>
                    <td>{row.make || '-'}</td>
                    <td>{row.mfgsrno || '-'}</td>
                    <td>{row.heatnobatchno || '-'}</td>
                    <td>{row.platenosrno || '-'}</td>
                    <td className="text-center fw-bold">{row.quantityreceived || '0'}</td>
                    <td className="text-center">{row.uom || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <button 
          className="btn btn-secondary btn-sm"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-1" />
          Back to List
        </button>
      </div>
    </Container>
  );
};

export default PIMRNView;